import styled from 'styled-components'
import Typography from 'builder/styles/typography'

export const Title = styled.div`
  ${Typography.Caps};
  font-weight: 600;
  margin-bottom: 8px;
`

export const ColorPickerPanelContainer = styled.div`
  width: 250px;
  margin: 0 auto;
`

export const PanelActions = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
`

export const PanelAction = styled.button`
  margin: 0;
  padding: 4px 12px;
  border: none;
  background: none;
  font-weight: 600;
`
